import styled, { css } from 'styled-components';

import { BaseButton } from '@r1-frontend/ui-react/components/buttons/baseButton';
import InputSimple, { nameDecorator, phoneDecorator } from '@r1-frontend/ui-react/components/inputSimple';
import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { Paragraph4 } from '@r1-frontend/ui-react/components/typography/paragraph';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

const InputNameDecorator = nameDecorator(InputSimple);
const InputPhoneDecorator = phoneDecorator(InputSimple);

export const Container = styled.div`
    background-color: ${COLORS.BgSurface};
    border-radius: 32px;
    padding: 24px;
    margin: 0 32px;

    @media (max-width: ${wideBreakpoints.sDesktop}) {
        margin: 0 32px;
    }

    @media (max-width: ${wideBreakpoints.laptop}) {
        margin: 0 24px;
    }

    @media (max-width: ${wideBreakpoints.tablet}) {
        margin: 0 0 36px;
    }

    @media (max-width: ${wideBreakpoints.mobile}) {
        margin: 0 0 28px;
        border-radius: 0;
        padding: 20px 16px;
    }
`;

export const BannerWrapper = styled.div`
    margin: 0 32px;

    @media (max-width: ${wideBreakpoints.laptop}) {
        margin: 0 24px;
    }

    @media (max-width: ${wideBreakpoints.tablet}) {
        margin: 0;
    }

    @media (max-width: ${wideBreakpoints.mobile}) {
        padding: 0 16px;
    }
`;

export const FormWrapper = styled.div`
    display: flex;
    width: 100%;
    gap: 16px;
    flex-direction: row;
`;

export const InputWrapper = styled.div`
    flex-direction: row;
    flex-basis: 100%;
    justify-content: center;
    gap: 12px;
`;

const CommonInputCss = css`
    margin-bottom: 0;
    width: calc(50% - 6px);

    @media (min-width: ${wideBreakpoints.sDesktop}) {
        width: calc(50% - 6px);
    }

    @media (max-width: ${wideBreakpoints.laptop}) {
        width: 100%;
    }

    @media (max-width: ${wideBreakpoints.tablet}) {
        width: calc(50% - 6px);
    }

    @media (max-width: ${wideBreakpoints.mobile}) {
        width: 100%;
    }
`;

export const InputPhone = styled(InputPhoneDecorator)`
    ${CommonInputCss};
`;

export const InputName = styled(InputNameDecorator)`
    ${CommonInputCss};
`;

export const ButtonWrapper = styled.div`
    flex-direction: column;
    gap: 32px;
    width: 100%;
`;

export const SubmitButton = styled(BaseButton)`
    ${FONTS.S};
    height: fit-content;
    width: 100%;
`;

export const CallbackButton = styled(BaseButton)<{ withTopSpace: boolean }>`
    ${FONTS.S};
    height: fit-content;
    width: 100%;
    ${(props) => props.withTopSpace ? 'margin-top: 16px;' : ''}
`;

export const TitleComponent = styled.div`
    ${FONTS.H4};

    @media (max-width: ${wideBreakpoints.mobile}) {
        ${FONTS.H5};
        text-align: center;
    }
`;

export const WrappperComponent = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    gap: 16px;
    padding-bottom: 32px;
`;

export const OldValue = styled(Paragraph4)`
    text-decoration-line: line-through;
    color: ${COLORS.TextInfo};
    margin-left: 36px;

    @media (max-width: ${wideBreakpoints.sMobile}) {
        margin-top: 8px;
    }
`;

export const ComponentHeader = styled.div`
    ${FONTS.H4};
    color: ${COLORS.TextPrimary};
    margin-bottom: 0px;

    @media (max-width: ${wideBreakpoints.mobile}) {
        ${FONTS.H5};
        margin-bottom: 4px;
    }
`;
